import React, {useRef, useState} from 'react';
import {useForm, FormProvider} from 'react-hook-form';
import {Box, Grid} from '@mui/material';
import FormSubmitButtons from '../pieces/formSubmitButtons';
import {yupResolver} from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import * as allConstants from '../constants/allConstants';
import Utils from '../utils/utils';
import ModalWrapper, {ModalContentWrapper} from '../pieces/modals/modalWrapper';
//import CustomFormBlock from '../pieces/inputs/formBlock';
//import {Text} from '../pieces/text';
import axios from 'axios';
import ApiUtils from '../utils/apiUtils';
import base_url from '../baseUrls';
//import * as STYLE_CONSTANTS from '../styles/styleConstants';
import Spacer from '../pieces/spacer';
import {inputTypes} from '../pieces/inputs/formInput';
import CustomFormBlock from '../pieces/inputs/formBlock';

export const useItemSelection = (props)=> {

  const [show, setShow] = useState(false);
  const [itemData, setItemData] = useState([]);
  const [jobNumber, setJobNumber] = useState('');
  const [selectedText, setSelectedText] = useState('');
  const curRowData = useRef(null);
  const targetFieldNames = useRef(null);

  //const submitAction = useRef(null);
  const headerText = 'Select ' + props?.title;

  const formInputDefaultProps = {
    viewMode: false,
    renderLabel: true,
  };

  const validationSchema = Yup.object().shape({
   // [allConstants.JOB_FIELDS.NOTE.TEXT.api_name]: Yup.string().required('Please leave a note')
  });

  const formOptions = {resolver: yupResolver(validationSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
    criteriaMode:'all',
  };

  const mainForm = useForm(formOptions);

  if(Utils.isDevEnv()) {
    window.mainForm = mainForm;
  }

  const onSubmit = async (data)=> {

    const assignee = data.selectedValue == 'UNASSIGNED' ? '' : data.selectedValue;
    const authToken =  await ApiUtils.getAccessToken();
    const body = { "jobId": curRowData.current.node.data["id"], [props.fieldName] : assignee };

    const url = `${base_url.api}ipermit/jobs/city-inspection/${props.method}`;
    
    axios.post(url, body, {headers: {Authorization: authToken,}}).then (() => {
      curRowData.current.node.setDataValue(props.apiName, assignee);
      props.okAction(assignee);
    });
    
    setShow(false);
  };

  const onCancel = ()=> {
    setShow(false);
  };

  //const showDialog = ({action}, assigneeData, params, fieldNames)=> {
  const showDialog = (assigneeData, params, fieldNames)=> {


    //console.log('params inside showDialog');
    //console.log(params);

    //console.log('param inside showDialaog');

    let fields = fieldNames.split(',');
    let defValue = null;

    for (var i=0; i < fields.length; i++) {
      if (i==0) {
        defValue = params.node.data[fields[i]]??"";
        //console.log('def value');
        //console.log(defValue);
      }
      else {
        //console.log('new default');
        //console.log(defValue);
        defValue = defValue[fields[i]]??"";
      }
    }
    //submitAction.current = action;
    curRowData.current = params;
    targetFieldNames.current = fieldNames;

    setItemData(assigneeData);
    defValue = defValue == '' ? 'UNASSIGNED' : defValue.toUpperCase()
    setSelectedText(defValue);

    //console.log('def value');
    //console.log(selectedText);

    setJobNumber(params.node.data['jobNumber']);
    setShow(true);
  };

  const mainDialog = () =><>
      <ModalWrapper modalName={'itemSelection'}
        handleClose={onCancel}
        open={show}
        preventScroll={true}
        width={{sx: '98%', sm: '600px'}}
        padding={6}
        customStyle={{paddingTop: 2}}
      >
        <ModalContentWrapper handleClose={onCancel} header={headerText} >
          <FormProvider {...mainForm}>
            <form onSubmit={mainForm.handleSubmit(onSubmit)} method={'POST'}>
              {/* <Text text={'this is a test'} color={STYLE_CONSTANTS.COLORS.globalRed} size={'xLarge'}/> */}
              {/* <CustomFormBlock
                  {...formInputDefaultProps}
                  field={allConstants.JOB_FIELDS.JOB_NUMBER.api_name}
                  inputType={inputTypes.number}
                  fullWidth
                  isEditable={false}
              />   */}
              <CustomFormBlock
                  {...formInputDefaultProps}
                  field={allConstants.GENERAL_FIELDS.SELECTED_VALUE}
                  inputType={inputTypes.singleSelect}
                  defaultValue={selectedText}
                  options={itemData}
                  fullWidth
                  isEditable={true}
                />
              <Grid>
                <Spacer y={2}/>
                <Box display={'flex'} justifyContent={'center'}>
                  <FormSubmitButtons cancelAction={onCancel}
                    submitText={'Select'} cancelText='Cancel'
                  />
                </Box>
              </Grid>
            </form>
          </FormProvider>
        </ModalContentWrapper>
      </ModalWrapper>
  </>;
  
  return {
    mainDialog: mainDialog,
    showDialog: showDialog,
    selectedText: selectedText,
  }
};